import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import type { Settlement } from 'state/secondaryMarket/shared/referential/referential.model';

import type { ClientType } from './form.models';

export function toSettlementTypeKey(
  settlementType: { settlementType?: string; marketType?: string } | undefined,
): string | undefined {
  if (settlementType === undefined) {
    return undefined;
  }
  return `${settlementType.settlementType}-${settlementType.marketType}`;
}

export function fromSettlementTypeKey(settlement: string | undefined) {
  if (settlement === undefined) {
    return undefined;
  }
  const [settlementType, marketType] = settlement.split('-', 2);
  return { marketType, settlementType };
}

export function toDefaultSettlementType(
  settlements: ReadonlyArray<Settlement> | undefined,
  tradeWay: TradeWay | undefined,
) {
  if (tradeWay === 'ClientBuy') {
    return settlements?.find(x => x.isDefaultBuy === true);
  }
  if (tradeWay === 'ClientSell') {
    return settlements?.find(x => x.isDefaultSell === true);
  }
  return undefined;
}

export function isClientSelected(client?: ISalesCounterpart, clientType?: ClientType) {
  if (clientType === 'Pending' || clientType === 'Pre-hedge') {
    return true;
  }
  return client !== undefined;
}

export function computeCashAmount(price?: number, denomination?: number, priceType?: SecondaryPriceType) {
  if (denomination === undefined || price === undefined || priceType === undefined) {
    return;
  }
  return priceType === 'Percent' ? price * (denomination / 100) : price;
}
